import { useCallback, useEffect, useState } from "react";
import kemHealthCheck from "../utils/kemHealthCheck";

interface UseKemHealthCheckOptions {
  autoCheck?: boolean;
  silent?: boolean;
}

export interface KemHealthCheckResult {
  kemHealthIsHealthy: boolean;
  hasCheckedHealth: boolean;
  runHealthCheck: () => Promise<boolean>;
}

const useKemHealthCheck = (
  options: UseKemHealthCheckOptions = {},
): KemHealthCheckResult => {
  const { autoCheck = true, silent = false } = options;
  const [kemHealthIsHealthy, setKemHealthIsHealthy] = useState(true);
  const [hasCheckedHealth, setHasCheckedHealth] = useState(false);

  const runHealthCheck = useCallback(async () => {
    const isHealthy = await kemHealthCheck({ silent });
    setKemHealthIsHealthy(isHealthy);
    setHasCheckedHealth(true);
    return isHealthy;
  }, [silent]);

  useEffect(() => {
    if (!autoCheck) return;
    void runHealthCheck();
  }, [autoCheck, runHealthCheck]);

  return {
    kemHealthIsHealthy,
    hasCheckedHealth,
    runHealthCheck,
  };
};

export default useKemHealthCheck;
